import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EMPTY_VALUE } from 'src/app/_helpers/utils';
import {
  FlowInvoiceInsight,
  FlowInvoiceReasonTone,
  getFlowInvoiceReason,
} from 'src/app/_types/billing.types';

/** The "Motif" cell: the gap reason, coloured by what it means for the client. */
@Component({
  selector: 'app-flow-invoice-reason-renderer',
  standalone: true,
  template: `<span [class]="'flow-invoice-reason tone-' + tone">{{
    label
  }}</span>`,
})
export class FlowInvoiceReasonRendererComponent
  implements ICellRendererAngularComp
{
  label = EMPTY_VALUE;

  tone: FlowInvoiceReasonTone = 'neutral';

  agInit(params: ICellRendererParams<FlowInvoiceInsight>): void {
    if (!params.data) return;

    const reason = getFlowInvoiceReason(params.data);
    this.label = reason.label;
    this.tone = reason.tone;
  }

  refresh(): boolean {
    return false;
  }
}
